import React, { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  Avatar,
  Box,
  ThemeProvider,
  createTheme,
  CssBaseline,
  Fade,
} from '@mui/material';
import CakeIcon from '@mui/icons-material/Cake';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';


const EmployeeBirthdayCard = () => {
  // 🎨 Dark Theme
  const theme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#90caf9',
      },
      secondary: {
        main: '#f48fb1',
      },
      background: {
        default: '#000000',
        paper: '#000000',
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
    },
  });

  // 🎉 Employee Info
  const name = 'Sushil Hagargi';
  const role = 'Co-Founder';
  const imageUrl = 'https://media.licdn.com/dms/image/v2/D5603AQGOT_v-bguZZA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1684219095216?e=2147483647&v=beta&t=_Y0GD0yf4pXTfmG5D3bdEGkB7J_yIl_7x5TvL5PdSE4';
  const message =
    "Your creativity brings joy to our team every day. Have a wonderful birthday! " +
    "We are so grateful for your positivity, dedication, and the unique energy you bring in every work you contribute. " +
    "May your year ahead be filled with exciting opportunities, great achievements, and endless happiness. " +
    "Here's to celebrating you today and always!";


  // Simple fade-in animation on load
  const [showCard, setShowCard] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShowCard(true), 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ textAlign: 'center', mt: 15, mb: 5 }}>
        <img
          src={Logo}
          alt="Logo"
          style={{
            width: '100%',
            maxWidth: '350px', // Cap the maximum size of the logo
            height: 'auto',
          }}
        />
      </Box>
      <Box
        sx={{
          minHeight: '50vh',
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Fade in={showCard} timeout={1000}>
          <Box
            sx={{
              width: 800,
              borderRadius: 4,
              boxShadow: 6,
              backgroundColor: theme.palette.background.paper,
              textAlign: 'center',
              p: 3,
              color: 'white',
            }}
          >
            <Avatar
              src={imageUrl}
              alt={name}
              sx={{ width: 100, height: 100, mx: 'auto', mb: 4 }}
            />
            <CakeIcon color="secondary" fontSize="large" sx={{ mb: 4, justifyContent: 'center', alignItems: 'center' }} />
            <Typography
              variant="h6"
              component="h1"
              color="white"
              sx={{ letterSpacing: 3, mb: 4, fontStyle: 'italic' }}
            >
              Team Anthrasync wishes you a very happy and auspicious birthday!
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 500,
                textAlign: 'center',
                fontSize: '2.5rem',
                backgroundImage: "linear-gradient(45deg, #00bfff, #ff00ff)",
                backgroundClip: "text",

                color: 'transparent',
                letterSpacing: 6,

                marginBottom: '40px',

              }}
            >
              {name}
            </Typography>

            <Typography variant="body1" sx={{ color: '#ddd', letterSpacing: 2 }}>
              {message}
            </Typography>
          </Box>
        </Fade>
      </Box>
    </ThemeProvider>
  );
};

export default EmployeeBirthdayCard;
